import { render, staticRenderFns } from "./DailyQuiz.vue?vue&type=template&id=628dbdba&scoped=true&"
import script from "./DailyQuiz.vue?vue&type=script&lang=js&"
export * from "./DailyQuiz.vue?vue&type=script&lang=js&"
import style0 from "./DailyQuiz.vue?vue&type=style&index=0&id=628dbdba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628dbdba",
  null
  
)

export default component.exports